import Act from "../actions";
import urls from "../../api/project/ApiUrls";
import role from "../../config/App-role";

const initState = {
  // displayName: "demo-user",
  // email: "demo@demo.com",
  // isAnonymous: false,
  role: role.anonymous,
  locale: urls.locale_lang.LOCALE_DEFAULT,
  authority: "free", // e.g. "free", "advance", "enterprise"
  refreshUserInfo: false,
  refreshUserGroups: false,
  token: null,
  group: {
    // uid: "ac",
    // displayName: "Alpha camp",
    // members: {
    //   aaaaaaa: {isMember: true, role: "admin"},
    //   bbbbbbb: {isMember: true, role: "editor"},,
    //   ccccccc: {isMember: true, role: "editor"},,
    //   ddddddd: {isMember: true, role: "editor"},,
    // },
  },
  // 這邊的資料結構與 realtime database 的 groups 相同
  groups: {
    // ac: {
    //   uid: "asdfasdfsfsadf",
    //   isMember: true,
    //   role: "editor",
    //   members: {}
    //   files: {}
    // },
    // tt: {
    //   uid: "asdfasdfsfsadf",
    //   isMember: true,
    //   role: "editor",
    //   members: {}
    //   files: {}
    // },
  },
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.SET_USER_LOCALE:
      return { ...state, locale: action.payload };
    case Act.SET_USER_TOKEN:
      return { ...state, token: action.payload };
    case Act.FIREBASE_LOGIN_USER:
      return { ...state, ...action.payload };
    case Act.FIREBASE_LOGOUT_USER:
      return { ...initState };
    case Act.USER_REFRESH_USER_INFO:
      return { ...state, refreshUserInfo: action.payload };
    case Act.USER_REFRESH_USER_GROUPS:
      return { ...state, refreshUserGroups: action.payload };
    case Act.USER_SET_CUR_GROUP:
      return { ...state, group: action.payload };
    case Act.USER_SET_GROUPS:
      return { ...state, groups: action.payload };
    case Act.USER_SET_ROLE:
      return { ...state, role: action.payload };
    default:
      return state;
  }
};

export default userReducer;
